










import { Component, Vue } from 'vue-property-decorator';
import { fetchGA4, fetchGoogleTagManager } from '@/fetchGoogleTagManager';

@Component
export default class CookieNotice extends Vue {
  public show = document.cookie.indexOf('gm-cookies') === -1;

  public dismiss() {
    this.show = false;
    Vue.$cookies.set('gm-cookies', 'true', 'Fri, 31 Dec 2039 23:59:59 GMT', undefined,  undefined, undefined, 'Lax');
    fetchGoogleTagManager();
    fetchGA4();
  }
}
